import {SalesCardsLazy} from 'app/components/salesCards/lazy';
import {getWebComponentLoader} from 'app/utils/initialize/getWebComponentLoader';

export function defineSalesCards(WebComponentLoader: ReturnType<typeof getWebComponentLoader>) {
    if (customElements.get('gem-sales-cards')) {
        return;
    }

    customElements.define(
        'gem-sales-cards',
        class extends WebComponentLoader {
            reactLazyComponent = SalesCardsLazy;
        },
    );
}
